import WelcomeProImage from 'assets/svgs/onboardingAlpha/welcome-pro.svg';
import PlaybookImage from 'assets/svgs/onboardingAlpha/playbook.svg';
import Welcome from '../components/Welcome';
import { IconArrowForward, Typography } from '@capitalise/ui-design-system';
import ImageTitleDescription from 'components/ImageTitleDescription';
import FlyingColleagues from 'assets/svgs/flying-colleagues.svg';
import InviteTeam from '../components/InviteTeam';
import HelpButton from '../components/HelpButton';
import AccountSetupImage from 'assets/svgs/account-setup.svg';
import ScheduleButton from '../components/ScheduleButton';
import { openIntercomChat } from 'utils/openIntercomChat';

export default ({ completeOnboarding, goToRoute, sendInviteSignup }) => {
  return [
    {
      label: 'Welcome',
      lead: 'We’re excited to have you onboard as a member of Capitalise Pro.',
      title: 'Welcome to the next level!',
      component: Welcome,
      iconButton: IconArrowForward,
      nextButtonLabel: 'Next',
      image: WelcomeProImage,
    },
    {
      label: 'Invite Team',
      title: 'Invite colleagues',
      component: ImageTitleDescription,
      hasPrevious: true,
      image: FlyingColleagues,
      iconButton: null,
      lead: 'Invite your funding team to collaborate with you on the platform.',
      children: <InviteTeam showBenefits />,
      asyncCustomNextFunction: sendInviteSignup,
      nextButtonLabel: 'Invite colleagues',
      skipButtonLabel: 'Leave for later',
    },
    {
      label: 'Playbook',
      title: 'Let’s start the Playbook',
      component: ImageTitleDescription,
      hasPrevious: true,
      image: PlaybookImage,
      iconButton: IconArrowForward,
      lead: 'Helpful marketing and strategic documents on how to turn Capitalise into a service line in your firm.',
      children: (
        <HelpButton
          helpLabel={
            <Typography size="body-16" color="grey-900">
              When <span style={{ fontWeight: 500 }}>at least 50%</span> of your team have completed
              the Learn modules we’ll arrange for you on-site funding training.
            </Typography>
          }
          buttonLabel="Start Learn"
          onClickCallback={() => {
            completeOnboarding();
            goToRoute('/learning/playbook');
          }}
        />
      ),
    },
    {
      label: 'All set',
      title: 'Your account is set up!',
      component: ImageTitleDescription,
      hasPrevious: true,
      image: AccountSetupImage,
      iconButton: null,
      lead: 'Your Capitalise partnership manager will schedule a kick-off meeting with you shortly.',
      nextButtonLabel: 'Go to dashboard',
      nextButtonAction: () => {
        completeOnboarding();
      },
      children: (
        <ScheduleButton
          helpLabel={
            <Typography size="heading-16" color="grey-900">
              Want to book a kick-off call now?
            </Typography>
          }
          buttonLabel="Schedule a call"
          onClickCallback={() => {
            openIntercomChat();
            completeOnboarding();
          }}
        />
      ),
    },
  ];
};
